/* do not edit. this file is generated by npm run lib:icons and constantly overwritten */
import React from 'react'
export const SvgCalendarWithDot = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={16}
    height={16}
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    role='img'
    {...props}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M14.3334 2H12.5C12.408 2 12.3334 1.92538 12.3334 1.83333V0.666667C12.3334 0.298477 12.0349 0 11.6667 0C11.2985 0 11 0.298477 11 0.666667V3.83333C11 4.10948 10.7762 4.33333 10.5 4.33333C10.2239 4.33333 10 4.10948 10 3.83333V2.33333C10 2.14924 9.8508 2 9.66671 2H5.50004C5.40825 2 5.33374 1.92579 5.33337 1.834V0.666667C5.33337 0.298477 5.0349 0 4.66671 0C4.29852 0 4.00004 0.298477 4.00004 0.666667V3.83333C4.00004 4.10948 3.77618 4.33333 3.50004 4.33333C3.2239 4.33333 3.00004 4.10948 3.00004 3.83333V2.33333C3.00004 2.14924 2.8508 2 2.66671 2H1.66671C0.930328 2 0.333374 2.59695 0.333374 3.33333V14.6667C0.333374 15.403 0.930328 16 1.66671 16H14.3334C15.0698 16 15.6667 15.403 15.6667 14.6667V3.33333C15.6667 2.59695 15.0698 2 14.3334 2ZM14.3334 14.3333C14.3334 14.5174 14.1841 14.6667 14 14.6667H2.00004C1.81595 14.6667 1.66671 14.5174 1.66671 14.3333V6.33333C1.66671 6.14924 1.81595 6 2.00004 6H14C14.1841 6 14.3334 6.14924 14.3334 6.33333V14.3333ZM10.3334 10C9.78109 10 9.33337 10.4477 9.33337 11V12.3333C9.33337 12.8856 9.78109 13.3333 10.3334 13.3333H11.6667C12.219 13.3333 12.6667 12.8856 12.6667 12.3333V11C12.6667 10.4477 12.219 10 11.6667 10H10.3334Z'
    />
  </svg>
)
export default SvgCalendarWithDot
